import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { OrganizationRequest, OrganizationResponse } from '@/types/organization';

export const organizationsApi = {
  list: (params?: SearchParams) =>
    unwrap(
      api.get<ApiResponse<PageResponse<OrganizationResponse>>>('/v1/organizations', { params }),
    ),

  get: (id: number) =>
    unwrap(api.get<ApiResponse<OrganizationResponse>>(`/v1/organizations/${id}`)),

  getCurrent: () =>
    unwrap(api.get<ApiResponse<OrganizationResponse>>('/v1/organizations/me')),

  create: (body: OrganizationRequest) =>
    unwrap(api.post<ApiResponse<OrganizationResponse>>('/v1/organizations', body)),

  update: (id: number, body: OrganizationRequest) =>
    unwrap(api.put<ApiResponse<OrganizationResponse>>(`/v1/organizations/${id}`, body)),

  delete: (id: number) =>
    unwrap(api.delete<ApiResponse<null>>(`/v1/organizations/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<OrganizationResponse>>(`/v1/organizations/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
